<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox
                                v-model="formData.status"
                                code="tuition_assistance_re_evaluations_statuses"
                                :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="explanation" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea v-model="formData.explanation"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";

// Services
import TuitionAssistanceService from "@/services/TuitionAssistanceService";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,

        ParameterSelectbox,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                status: null,
                explanation: null,

            },
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            TuitionAssistanceService.get(id)
                .then(response => {
                    let data = response.data.data;
                    this.formData = {
                        status: data.status,
                        explanation: data.explanation,

                    }

                })
                .catch(e => {
                    this.showErrors(e)
                })
        },

        async updateForm() {
            if (this.checkPermission('tuitionassistancereevaluation_preevaluate')) {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    TuitionAssistanceService.preEvaluate(this.formId, this.formData)
                        .then(response => {
                            this.$emit('preEvaluateFormSuccess', true);
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
